import { createStore } from 'vuex';

export default createStore({
  state: {
    appMode: 'light',
  },
  mutations: {
    setAppMode(state, mode) {
      state.appMode = mode || 'light';
    },
  },
  actions: {
    setAppMode({ commit }, mode) {
      commit('setAppMode', mode);
    },
  },
  modules: {
  },
});
